"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const ConstraintUtils_1 = require("../../ConstraintUtils");
const validate = (validations) => {
    const validateResults = validations.map((validation) => mapper(validation));
    function toChecked(validation) {
        return new ConstraintUtils_1.Checked(validation.tag, ConstraintUtils_1.Status.ERROR, validation.message);
    }
    function toCheckedSuccess(tag) {
        return new ConstraintUtils_1.Checked(tag, ConstraintUtils_1.Status.INFO, 'ok');
    }
    function mapper(validation) {
        let result;
        try {
            if (validation.predicate(validation.target)) {
                result = toCheckedSuccess(validation.tag);
            }
            else {
                result = toChecked(validation);
            }
        }
        catch (error) {
            result = toChecked(validation);
        }
        return result;
    }
    const accumulateErrors = (accumulator, checked) => {
        if (checked.status !== ConstraintUtils_1.Status.INFO) {
            accumulator.push(checked);
        }
        return accumulator;
    };
    const validated = validateResults.reduce(accumulateErrors, []);
    if ((0, ConstraintUtils_1.hasErrors)(validated)) {
        return validated;
    }
    else {
        return [toCheckedSuccess('root')];
    }
};
exports.validate = validate;
